import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import './mixin'

Vue.config.productionTip = false

// 시스템 이벤트 핸들러: 우클릭 금지
addEventListener('contextmenu', event => event.preventDefault())

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')